import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextColor = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M7 18C7.66667 18 13.9444 18 17 18",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8 14.7273L9.44886 11.5661M9.44886 11.5661L11.8182 6.39668C11.8895 6.24112 12.1105 6.24112 12.1818 6.39668L14.5511 11.5661L16 14.7273M14.5511 11.5661H9.44886",
		stroke: "black",
		strokeLinecap: "round"
	})]
});
export default SvgTextColor;
